export type Validations = Record<string, TransactionValidation[]>

export enum LinkedStatus {
  MATCHED = 'MATCHED',
  CUSTODY_MATCHED = 'CUSTODY_MATCHED',
  TRADING_MATCHED = 'TRADING_MATCHED',
  UNMATCHED = 'UNMATCHED',
}

export enum TransactionMatching {
  all = 'All',
  custody = 'Custody',
  trading = 'Trading',
}

export interface TransactionValidation {
  validationId: string
  message: string
}

export interface ClearwaterTransaction {
  accountName?: string
  tranId: string
  accountId: number
  rowId: string
  legacyTranId?: number
  legacyOrigId?: number //

  // Common transaction data
  tranTypeCode: string //
  entryDate?: string //
  settleDate?: string //
  postDate?: string //
  clearedTimestamp?: string //
  createdTimestamp?: string //
  units?: number //
  amount?: number //
  price?: number //
  accrued?: number //
  commission?: number //
  originationFee?: number
  exitFee?: number
  exitFeeReceivable?: number
  drawFee?: number
  prepaymentPenaltyFee?: number
  delinquencyFee?: number
  modificationFee?: number
  miscellaneousFee?: number
  prepaidInterest?: number
  interestDue?: number

  // Security related data
  secId?: number
  secIdentifier?: string
  secCusip?: string
  secIsin?: string //
  secFigi?: string
  secSedol?: string
  secTypeCode?: string //
  secSubType?: string
  secDescription?: string
  currencyCode?: string //
  sellCurrency?: string
  secTicker?: string
  cwanIdentifier?: string

  // Uncommon transaction data
  tradeDate?: string
  sellUnits?: number //
  sellToBuyRate?: number
  typeLabel?: string //
  xferAccountId?: number //
  userName?: string //
  sourceName?: string
  marginEffect?: number //
  isCapitalize?: boolean

  // Matched external transaction data
  extReconDate?: string //
  extAggregateInfo?: string
  extAccrued?: number
  extCurrencyCode?: string
  extCusip?: string //
  extDescription?: string //
  extPostDate?: string
  extIdentifier?: string
  extTranIds?: number[]

  // Other related data
  tranNote?: string
  custodyLinkedStatus?: boolean
  tradingLinkedStatus?: boolean
  amountByCurrencyCode?: Map<string, number>
  validations?: Validations
  linkedStatus?: LinkedStatus

  custodyMatches?: number

  tradingMatches?: number
  availableActions?: ClearwaterAvailableActionTypes[]
  contractIdentifier?: string
  collateralBroker?: string
  tranSource?: string
  factor?: number
  hasSpecLotMatches?: boolean
  custodyAmountDifference?: number
  tradingAmountDifference?: number
  elmClientTranId?: string
  elmLotEffects?: string
  elmSecId?: number
  basis?: string
  dataMap?: string
}

export type ClearwaterAvailableActionTypes =
  | 'adjustBy'
  | 'clear'
  | 'clearAndSetPost'
  | 'delete'
  | 'deleteAndIgnore'
  | 'editNote'
  | 'editSpecLotMatch'
  | 'editTran'
  | 'manyToManyMatch'
  | 'match'
  | 'matchUsingExternal'
  | 'unclear'
  | 'unmatch'

export interface ClearwaterTransactionsSetValues {
  tranTypeCodes: string[]
  secTypeCodes: string[]
  currencyCodes: string[]
  userNames: string[]
  linkedStatus: LinkedStatus[]
  accountIds: number[]
  accountNames: string[]
  sellCurrencies: string[]
}

export interface ClearwaterTransactionsFilterContext {
  filterContext: {
    extDataSourceType?: ExtDataSourceType
    fxCurrency?: string[]
  }
}

export interface ClearwaterTransactionsAdvancedOptions {
  clearedTimestampToggle: boolean
  unclearedTimestampToggle: boolean
}

export type ExtDataSourceType = 'Custody' | 'Trading'
